module.exports = __webpack_public_path__ + "static/cd-ht-intro-image-1-a78441c411e4dd5c5f58a1be8c827556.jpeg";